import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Sparkles } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { useLanguage } from '../contexts/LanguageContext';
import { ProductCard } from './ProductCard';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getRecentViews = () => {
  try {
    return JSON.parse(localStorage.getItem('rm_recent_views') || '[]');
  } catch {
    return [];
  }
};

export const recordProductView = (productId) => {
  try {
    const arr = getRecentViews().filter((id) => id !== productId);
    arr.unshift(productId);
    localStorage.setItem('rm_recent_views', JSON.stringify(arr.slice(0, 20)));
  } catch { /* ignore */ }
};

export const RecommendedProducts = ({ excludeId = null, limit = 8 }) => {
  const { token } = useAuth();
  const { language } = useLanguage();
  const T = (fr, en) => (language === 'fr' ? fr : en);
  const [data, setData] = useState(null);

  useEffect(() => {
    const run = async () => {
      try {
        const viewed = getRecentViews();
        const headers = token ? { Authorization: `Bearer ${token}` } : {};
        const r = await axios.get(`${API}/recommendations`, {
          params: { viewed: viewed.join(','), limit },
          headers,
        });
        setData(r.data);
      } catch {
        setData(null);
      }
    };
    run();
  }, [token, limit]);

  const products = (data?.products || []).filter((p) => p.id !== excludeId);
  if (!data?.personalized || products.length === 0) return null;

  return (
    <section className="container-main py-16" data-testid="recommended-section">
      <div className="flex items-center gap-3 mb-8">
        <div className="w-11 h-11 bg-[#E9C46A] rounded-xl flex items-center justify-center">
          <Sparkles className="w-6 h-6 text-[#0F4C5C]" />
        </div>
        <div>
          <h2 className="text-2xl md:text-3xl font-bold text-[#0F4C5C]">
            {T('Recommandé pour vous', 'Recommended for you')}
          </h2>
          <p className="text-sm text-muted-foreground">
            {T('Sélectionné selon vos achats et votre navigation', 'Picked based on your purchases and browsing')}
          </p>
        </div>
      </div>
      <div className="product-grid">
        {products.slice(0, limit).map((product) => (
          <ProductCard key={product.id} product={product} />
        ))}
      </div>
    </section>
  );
};
